import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_REPORT_FOLDERS = `${REPORT}_SET_REPORT_FOLDERS`;
export const SET_DASHBOARD_FOLDERS = `${REPORT}_SET_DASHBOARD_FOLDERS`;
export const RESET_REPORTLIST_STORE = `${REPORT}_RESET_REPORTLIST_STORE`;



// WEBPACK FOOTER //
// ./src/views/ReportList/flow/actionTypes.js